<template>
  <v-app>
    <v-main  class="mandalabg">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>
